import { computed, defineComponent, ref } from 'vue';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { ProcureGetter } from '@/store/procure/procure.module';
import { Procure, ProjectEndDate } from '@/store/procure/procure.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProjectProcureEndDateModalComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    projectId: {
      type: Number
    }
  },
  emits: [
    'create',
    'edit',
  ],
  setup: (_, context) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const procure = computed<Procure>(() => store.getters[ProcureGetter.GET]);
    const endDates = computed<ProjectEndDate[]>(() => procure.value?.endDates);
    const endDateModal = ref<InstanceType<typeof BaseModalComponent>>();

    // show modal
    const show = () => {
      endDateModal.value?.show();
    };

    // hide modal
    const hide = () => {
      endDateModal.value?.hide();
    };

    const createClick = () => {
      context.emit('create');
    };

    const editClick = (id: number) => {
      context.emit('edit', id);
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'long');

    return {
      endDates,
      endDateModal,
      show,
      hide,
      createClick,
      editClick,
      thaiDate,
    };
  },
});
